// ACTION TYPE SEND_MAIL
export const SEND_MAIL = 'SEND_MAIL';
// ACTION CREATOR sendMessage
export const sendMessage = () => ({
  type: SEND_MAIL,
});
